import React from 'react';

import ic_user_group_customize from 'assets/images/ic_user_group_customize.svg';

import { func_validation } from 'functions';

export const userListColumns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_fullName,
    getColumns_username,
    getColumns_role,
    getColumns_referenceCode,
    getColumns_userGroup,
}

function getColumns(props) {
    return [
        getColumns_fullName(),
        getColumns_username(),
        getColumns_userGroup(props),
        // getColumns_referenceCode(),
        // getColumns_role(),
    ];
}

function getColumns_fullName() {
    let columnClassName = "userList-tableColumn-firstName";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Full Name",
        id: "fullName",
        accessor: "FullName",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let value_formatted = func_validation.getTableCellValue_string(props);

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}


function getColumns_username() {
    let columnClassName = "userList-tableColumn-username";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Username",
        id: "username",
        accessor: "UserName",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let value_formatted = func_validation.getTableCellValue_string(props, "");

            let row = func_validation.getObjectPropertyValue(props, "row");
            let rowDepth = func_validation.getObjectPropertyValue(row, "depth");
            let isSubrow = (rowDepth > 0);

            return isSubrow? "":(
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_role() {
    let columnClassName = "userList-tableColumn-role";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Role",
        id: "role",
        accessor: "Role",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let value_formatted = func_validation.getTableCellValue_string(props);

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_userGroup(props) {
    let columnClassName = "userList-tableColumn-userGroup";

    return {
        headerCellClassName: "userList-tableColumn-userGroup-header " + columnClassName + " ",
        Header: "User Group",
        id: "userGroup",
        accessor: "UserGroup",
        bodyCellClassName: columnClassName + " ",
        Cell: (cellProps) => {
            let row = func_validation.getObjectPropertyValue(cellProps, "row");
            let rowIdx = func_validation.getObjectPropertyValue(row, "index");
            let depth = func_validation.getObjectPropertyValue(row, "depth");
            let isSubrow = (depth > 0);
            
            let original = func_validation.getObjectPropertyValue(row, "original");

            let selectedUserGroup = func_validation.getObjectPropertyValue(cellProps, "value");
            let totalGroups = func_validation.getArrayLength(selectedUserGroup, 0);
            let selectedIndexes = [];
            let groupDetailsDisplay = [];

            if (func_validation.isArrayNotEmpty(selectedUserGroup)) {

                groupDetailsDisplay = selectedUserGroup.map((userGroupObj, idx) => {
                    let groupName = func_validation.getObjectPropertyValue(userGroupObj, "groupName");
                    let selectedIndex = func_validation.getObjectPropertyValue(userGroupObj, "selectedIndex");
                    selectedIndexes.push(selectedIndex);

                    return (<div key={idx}>{groupName}</div>);
                })
            }

            let isUserGroupMappingHidden = false && func_validation.isUserAccessDenied(props, "Dealer_UserGroupMapping_View");

            return isSubrow? (
                <div className={"userList-tableColumn-userGroup-cell-subrow"}>
                    {groupDetailsDisplay}
                </div>
            ):(
                <div className={"userList-tableColumn-userGroup-cell "}
                    onClick={() => {
                        if (!isUserGroupMappingHidden) {
                            // User Group Modal
                            if (props.setIsModalVisible_userGroup)
                                props.setIsModalVisible_userGroup(true);

                            // User Goup List
                            if (props.setSelectedUserGroupIndexList &&
                                func_validation.isArray(selectedIndexes))
                                props.setSelectedUserGroupIndexList(selectedIndexes);

                            // Set user email
                            if (props.setSelectedUserDetail &&
                                func_validation.isObjectNotEmpty(original))
                                props.setSelectedUserDetail(original);
                        }
                    }}
                >
                    <div className={"userList-tableColumn-userGroup-cellWrapper noWrap-text-ellipsis d-flex justify-content-between " +
                            (isUserGroupMappingHidden? "userList-tableColumn-userGroup-cellWrapper_noHover ":"")}>
                        <span>
                            {totalGroups} Group(s)
                        </span>

                        {(!isUserGroupMappingHidden)? (
                            <img
                                src={ic_user_group_customize}
                                alt={"Gear Icon"}
                            />
                        ):""}
                    </div>
                </div>
            );
        },
    }
}

function getColumns_referenceCode() {
    let columnClassName = "userList-tableColumn-referenceCode";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Reference Code",
        id: "referenceCode",
        accessor: "ReferenceCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let value_formatted = func_validation.getTableCellValue_string(props);

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}